export const getXtdPreviewDataV2 = () => {
  return {
    "cityID": 52260100,
    "cityName": "Ciudad Obregon",
    "country": "MX",
    "cityList": [],
    "activityID": "5764626554801881226",
    "share": {
        "title": "Invita amigos y obt\u00e9n hasta MXN$xxx",
        "countdownTip": {
            "day": 5,
            "hour": 23
        },
        "showCode": "FOOD-FLK9MW",
        "shareOptions": {
            "referralCode": "Regístrate con este código FOOD-FLK9MW y comienza a ganar con DiDi Food.",
            "default": {
                "title": "Comienza a ganar con DiDi Food.",
                "content": "Sube tus documentos hoy, es fácil y rápido.",
                "icon": "https://img0.didiglobal.com/static/soda_public/do1_MI6smT4AzE6guEkAMIEs",
                "imgUrl": [
                    {
                        "urlHttps": "https://img0.didiglobal.com/static/soda_public/do1_MI6smT4AzE6guEkAMIEs",
                        "key": "do1_MI6smT4AzE6guEkAMIEs"
                    }
                ]
            }
        },
        "shareOrder": [
            "whatsapp",
            "facebook",
            "twitter"
        ],
        "selectShare": "whatsapp",
        "imgUrl": "https://img0.didiglobal.com/static/gstar/img/KvFTzTnLjy1712547431401.png"
    },
    "rule": {
        "title": "Si tu amigo completa xxx pedido(s), podrás obtener hasta MXN$xxx en recompensas",
        "attention": "Para participar válidamente, tus amigos tienen que registrarse con el/los siguiente(s) vehículo(s) y completar pedidos en Ciudad Obregon",
        "vehicles": [
            "Bicicleta eléctrica",
            "Motocicleta",
            "Automóvil"
        ]
    },
    "records": [
        {
            "define": [],
            "ID": 5764636537568365000,
            "phone": "+52 000****6885",
            "amount": 0,
            "amount_display": "MXN$0.00",
            "amount_highlight_display": {
                "symbol": "MXN$",
                "number": "0.00",
                "position": 0,
                "display": "MXN$0.00",
                "sign": ""
            },
            "activeTime": 1666085391,
            "activeTime_display": {
                "timestamp": 1666085391,
                "offset": -25200
            },
            "createTime": 1666085383,
            "createTime_display": {
                "timestamp": 1666085383,
                "offset": -25200
            },
            "currency": "MXN",
            "deliveryCount": 0,
            "status": 3,
            "subtext": "Faltan 192 pedidos",
            "message": "Faltan 28 días",
            "cityId": 52260100,
            "cityName": "Ciudad Obregon",
            "initVehicleType": "Bicicleta eléctrica",
            "headImg": "https://pt-starimg.didistatic.com/static/starimg/img/1534919180546Ik83UsKQYIBbiEu0lOe.png",
            "statusDesc": "",
            "description": "",
            "progressBar": {
                "head": {
                    "top": "MXN$",
                    "bottom": "Pedidos"
                },
                "levels": {
                    "1": {
                        "top": "xxx",
                        "bottom": 'xxx',
                        "finish": false
                    },
                    "2": {
                        "top": "xxx",
                        "bottom": 'xxx',
                        "finish": false
                    },
                    "3": {
                        "top": "xxx",
                        "bottom": 'xxx',
                        "finish": false
                    }
                },
                "currentLevel": 0,
                "currentNumber": 0,
                "rewardAmount": 0,
                "rewardAmountDisplay": "MXN$0.00",
                "maxNumber": 192,
                "maxAmountDisplay": "MXN$4,000.00"
            },
            "levelCount": 3,
            "displayType": 1
        },
        {
            "define": [],
            "ID": 5764642730152036000,
            "phone": "+52 000****4328",
            "amount": 400000,
            "amount_display": "MXN$xxx",
            "amount_highlight_display": {
                "symbol": "MXN$",
                "number": "4,000.00",
                "position": 0,
                "display": "MXN$xxx",
                "sign": ""
            },
            "activeTime": 1677843389,
            "activeTime_display": {
                "timestamp": 1677843389,
                "offset": -25200
            },
            "createTime": 1677843377,
            "createTime_display": {
                "timestamp": 1677843377,
                "offset": -25200
            },
            "currency": "MXN",
            "deliveryCount": 192,
            "status": 1,
            "subtext": "",
            "message": "",
            "cityId": 52260100,
            "cityName": "Ciudad Obregon",
            "initVehicleType": "Bicicleta eléctrica",
            "headImg": "https://pt-starimg.didistatic.com/static/starimg/img/1534919180546Ik83UsKQYIBbiEu0lOe.png",
            "statusDesc": "Completado",
            "description": "Completado",
            "progressBar": {
                "head": {
                    "top": "MXN$",
                    "bottom": "Pedidos"
                },
                "levels": {
                    "1": {
                        "top": "xxx",
                        "bottom": 'xxx',
                        "finish": true
                    }
                },
                "currentLevel": 1,
                "currentNumber": 192,
                "rewardAmount": 400000,
                "rewardAmountDisplay": "MXN$xxx",
                "maxNumber": 192,
                "maxAmountDisplay": "MXN$xxx"
            },
            "levelCount": 1,
            "displayType": 1
        }
    ]
}
}